import React from 'react';
import { translate } from '../../../utils/translations';
import PropTypes from 'prop-types';

const Monochrome = props => (
    <div className="form__item">
        <label htmlFor="colorString">
            {translate(props.language, 'label_color')}
        </label>
        <input
            type="text"
            name="colorString"
            id="colorString"
            value={props.colorString}
            onChange={props.handleChange}
            maxLength="7"
            className="input-color"
        />
        {props.errorMessageColor && (
            <span className="error-message error-message-color color-item">
                {translate(props.language, 'form_err_color')}
            </span>
        )}
        <input
            type="color"
            name="color"
            id="color"
            value={props.color}
            onChange={props.handleChange}
            className="color-picker"
        />
        <div className="fake-input-color">
            <div
                style={{
                    background: props.color,
                }}
            />
        </div>
    </div>
);

Monochrome.propTypes = {
    language: PropTypes.string,
    colorString: PropTypes.string,
    color: PropTypes.string,
    handleChange: PropTypes.func,
};

export default Monochrome;



// WEBPACK FOOTER //
// ./src/containers/Configurador/FormPartials/Monochrome.js